export default "__VITE_ASSET__Cpz1LO2Z__"